import "./App.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Route, Routes } from "react-router-dom";
import Uploads from "./pages/uploads";
import Dashboard from "./pages/dashboard";
import LoginPage from "./pages/login";
import TransactionsList from "./pages/tableSample";
import UserList from "./pages/userList";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CreateBatch from "./pages/crateBatch";
import UpdateBatch from "./pages/updateBatch";
import PrivacyPolicy from "./pages/privacyPolicy";
import TermsAndConditions from "./pages/termsAndConditions";
import TaxInvoicePDF from "./pages/reciept";
import LandingPage from "./pages/LandingPage";
import DeleteAccount from "./pages/deleteAccount";
import "./css/dashboardGlass.css";
import "./css/theme.css";
import AdminLayout from "./components/AdminLayout";


function App() {
  return (
    <>
      <Routes>
        <Route path="/"  Component={LandingPage} />
        <Route path="/Kishore"  Component={LoginPage} />
        <Route element={<AdminLayout />}>
          <Route path="/dashboard" Component={Dashboard} />
          <Route path="/uploads" Component={Uploads} />
          <Route path="/userlist" Component={UserList} />
          <Route path="/transactions" Component={TransactionsList} />
          <Route path="/crateBatch" Component={CreateBatch} />
          <Route path="/updateBatch" Component={UpdateBatch} />
        </Route>
        <Route path="/privacyPolicy" Component={PrivacyPolicy} />  
        <Route path="/termsAndConditions" Component={TermsAndConditions}/>
        <Route path="/rcpt" Component={TaxInvoicePDF}/>
        <Route path="/home" Component={LandingPage}/>
        <Route path="/deleteAccount" Component={DeleteAccount}/>
        
      
      </Routes>
      <ToastContainer />
    </>
  );
}

export default App;
